import dynamic from 'next/dynamic';

const ChartBar = dynamic(() => import('./ChartBar/ChartBar'));

export { ChartBar };
